import './BeginGenerate.scss';
import Card from 'components/chrome/Card';
//import ApiSummary from 'components/api/ApiSummary';
import DisplayModel from 'components/chrome/DisplayModel';
import ApiVersion from 'models/ApiVersion';
import React from 'react';
import { Button } from 'primereact/button';
import { NavLink } from 'react-router-dom';
import Sitemap from 'components/app/Sitemap';
import AuditService from 'components/audit/AuditService';


class BeginGenerate extends React.Component {

  constructor() {
    super();
    this.state = {};
    this.sitemap = new Sitemap.Factory().create();
    this.auditSvc = new AuditService.Factory().create();
  }

  renderConfirmation() {
    if (this.state.confirmed) {
      return (
        <Card
            className='section'
            header='Confirmation'
            text="Your API is being generated. You'll receive an email when it is complete. In the meantime, you can continue to browse."
        />
      );
    }
    return (
      <Card
          className='section'
          header='Confirmation'
          text='Clicking "confirm" will create a new revision of your API. It will be ready for use in 2 hours.'
          buttonPrimaryLabel='Confirm'
          buttonPrimaryAction={this.onConfirm.bind(this)} />
    );
  }

  onConfirm() {
    this.setState({confirmed: true});
    this.auditSvc.log('Created new API version');
  }

  render() {
    return (
      <div className='BeginGenerate'>
        <div className='section'>
          <div className='subtitle'>Generate environment</div>
          <p>Finalize settings and confirm to generate a new environment.</p>
        </div>
        <Card
            className='section'
            header='New API summary'
            text='These are the settings that will be used for the creation of your new API. To make changes, navigate back to "Configure".'
            childrenPadded>
          <DisplayModel
              data={new ApiVersion({
                version: '1.0.0',
                dataTypes: ['Pulse Rate', 'Pulse Oximetry', 'ECG'],
                security: 'One-way SSL with 256-bit AES-ECB sessions',
                changelog: 'Added data type ECG',
              })} />
        </Card>
        {this.renderConfirmation()}
        <div className='section'>
          <div className='right'>
            <NavLink to={this.sitemap.getNextUrl()}>
              <Button icon='pi pi-chevron-right' iconPos='right' label='Continue' disabled={!this.state.confirmed} />
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}


export default BeginGenerate;
